import { type BlockConfig, iconField } from './_types';

/**
 * Payload `Block` config sidecar for the `trustSection` block.
 *
 * Decomposed from `src/components/home/TrustSection.tsx`. Also covers the
 * shapes of `protect/ProtectTrust.tsx` and `b2b/B2BTrust.tsx` (4-card
 * narrow strip of trust indicators).
 *
 * Slug + interfaceName naming reconciliation:
 *   File name:               `trust-section.tsx` / `trust-section.payload.ts`
 *   React component export:  `TrustSection`
 *   Payload `slug`:          `trustSection`
 *   Payload `interfaceName`: `TrustSectionBlock`
 */

export const TrustSectionBlock: BlockConfig = {
  slug: 'trustSection',
  interfaceName: 'TrustSectionBlock',
  labels: {
    singular: 'Trust Section',
    plural: 'Trust Section Blocks',
  },
  fields: [
    {
      name: 'eyebrow',
      type: 'text',
      label: 'Eyebrow',
    },
    {
      name: 'headline',
      type: 'text',
      label: 'Headline (optional)',
      admin: {
        description:
          'B2B trust strips often render without a headline; leave blank to omit the section header.',
      },
    },
    {
      name: 'columns',
      type: 'select',
      defaultValue: '4',
      label: 'Columns',
      options: [
        { label: '2', value: '2' },
        { label: '3', value: '3' },
        { label: '4', value: '4' },
      ],
    },
    {
      name: 'bgVariant',
      type: 'select',
      defaultValue: 'muted',
      label: 'Background variant',
      options: [
        { label: 'Muted (with border-y)', value: 'muted' },
        { label: 'Default', value: 'default' },
      ],
    },
    {
      name: 'items',
      type: 'array',
      required: true,
      minRows: 2,
      maxRows: 8,
      label: 'Items',
      labels: { singular: 'Item', plural: 'Items' },
      fields: [
        iconField({
          name: 'icon',
          label: 'Icon (lucide-react name)',
          required: true,
        }),
        { name: 'title', type: 'text', required: true, label: 'Title' },
        {
          name: 'description',
          type: 'text',
          label: 'Description',
        },
      ],
    },
  ],
};

export default TrustSectionBlock;
